import { useState } from 'react';

import { PostComment } from '@/fo/ui/comment/section/base';

import { getCommentsData } from '../api/getCommentsData';
import { mapComments } from '../helpers/mapComments';

const INITIAL_PAGE = 1;

export function useComments(
  slug: string,
  initialComments: PostComment[],
  initialCommentsCount: number
) {
  const [comments, setComments] = useState<PostComment[]>(initialComments);

  const [commentsPage, setCommentsPage] = useState(INITIAL_PAGE);
  const [commentsLoading, setCommentsLoading] = useState(false);
  const [showLoadMore, setShowLoadMore] = useState(initialCommentsCount > 10);

  const fetchMoreComments = async () => {
    setCommentsLoading(true);

    const { postData, pageInfo } = await getCommentsData(
      slug,
      commentsPage + 1
    );

    const comments = await mapComments(postData);

    setComments((prev) => {
      const allItems = [...prev, ...comments];
      const uniqueMap = new Map(allItems.map((item) => [item.id, item]));
      const uniqueItems = Array.from(uniqueMap.values());
      return uniqueItems;
    });

    const totalPages = pageInfo?.total_pages ?? 0;

    setShowLoadMore(totalPages > commentsPage + 1);
    setCommentsPage(commentsPage + 1);
    setCommentsLoading(false);
  };

  return {
    comments,
    fetchMoreComments,
    showLoadMore,
    commentsLoading
  };
}
